import { render, staticRenderFns } from "./PoliticasDePrivacidad.vue?vue&type=template&id=ac26938e&scoped=true&"
import script from "./PoliticasDePrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticasDePrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasDePrivacidad.vue?vue&type=style&index=0&id=ac26938e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac26938e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
